// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"46":"c90e89b2","774":"5794d9d6"}[chunkId] + ".chunk.js";
};